import * as React from "react";
import { Link } from "@tanstack/react-router";
import { Phone, CalendarCheck } from "lucide-react";

import { cn } from "@/lib/utils";
import { NAP, SHOW_PHONE } from "@/lib/business";
import { BOOK_CTA_LABEL } from "@/lib/nav";
import { Button } from "@/components/ui/button";
import { CtaButton } from "@/components/CtaButton";

export function MobileActionBar() {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={cn(
        "fixed inset-x-0 bottom-0 z-50 border-t border-ink-200 bg-paper-50/95 backdrop-blur-xl transition-brand md:hidden",
        visible ? "translate-y-0" : "translate-y-full",
      )}
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      aria-hidden={!visible}
    >
      <div
        className={cn(
          "grid min-h-16 items-center gap-2 px-3 py-2",
          SHOW_PHONE ? "grid-cols-[auto_minmax(0,1fr)]" : "grid-cols-1",
        )}
      >
        {SHOW_PHONE ? (
          <Button asChild variant="secondary" size="sm" className="w-full px-4">
            <a href={NAP.phoneHref} tabIndex={visible ? 0 : -1}>
              <Phone className="size-4" aria-hidden="true" />
              Call
            </a>
          </Button>
        ) : null}
        <CtaButton asChild size="sm" className="w-full min-w-0 px-3">
          <Link to="/book" tabIndex={visible ? 0 : -1}>
            <CalendarCheck className="size-4 shrink-0" aria-hidden="true" />
            <span className="truncate min-[360px]:hidden">Book a Call</span>
            <span className="hidden truncate min-[360px]:inline">{BOOK_CTA_LABEL}</span>
          </Link>
        </CtaButton>
      </div>
    </div>
  );
}

export default MobileActionBar;
